import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { notification } from 'redux/modules/app'
import { organizations as organizationsApi } from 'redux/modules/api'


function decorator(config = {}) {
  return ComposedComponent => {
    @connect(
      ({ api }) => ({
        organizations: api.organizations,
        gopList: api.organizations.gopList
      }),
      { ...organizationsApi, notification, push }
    )
    class Organizations extends Component {
      static propTypes = {
        fetchGlobalOperatingPartner: PropTypes.func.isRequired,
        fetchSubGlobalOperatingPartner: PropTypes.func.isRequired,
        getOrganizationClientCustomization: PropTypes.func.isRequired,
        gopList: PropTypes.array,
        notification: PropTypes.func.isRequired,
        push: PropTypes.func.isRequired
      }

      handleError = err => {
        this.props.notification(
          err.body &&
            (err.body.userMessage || err.body.developerMessage || 'Error'),
          'error'
        )
        throw err
      }

      handleFetchGlobalOperatingPartners = () => {
        return this.props.fetchGlobalOperatingPartner()
      }

      handleFetchSubGlobalOperatingPartners = gopId => {
        return this.props.fetchSubGlobalOperatingPartner(gopId)
      }

      handleGetOrganizationClientCustomization = code => {
        return this.props.getOrganizationClientCustomization(`homePageCode=${code}`)
      }


      render() {
        return (
          <ComposedComponent
            {...this.props}
            onFetchGlobalOperatingPartners={this.handleFetchGlobalOperatingPartners}
            onFetchSubGlobalOperatingPartners={this.handleFetchSubGlobalOperatingPartners}
            onGetOrganizationClientCustomization={this.handleGetOrganizationClientCustomization}
          />
        )
      }
    }
    return Organizations
  }
}

export default decorator
